import { useState, useEffect } from 'react';

export default function Footer() {
  const [time, setTime] = useState('');
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      // Ponorogo is Asia/Jakarta timezone
      const options = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'Asia/Jakarta',
      };
      const formatter = new Intl.DateTimeFormat('en-US', options);
      setTime(formatter.format(now));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className='flex flex-col'>
      <div className='flex flex-wrap gap-3'>
        {/* <a href='https://x.com/dinivannendra' target='_blank' className='text-sm opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out'>
          X
        </a> */}
        <a href='https://www.linkedin.com/in/dinivan-nendra-gunawan/' target='_blank' className='text-sm opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out'>
          Linkedin
        </a>
        <a href='mailto:dinivannendragunawan@gmail.com' target='_blank' className='text-sm opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out'>
          Email
        </a>
        <a href='https://github.com/unaivan22' target='_blank' className='text-sm opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out'>
          Github
        </a>
        <a href='https://layers.to/dinivannendra' target='_blank' className='text-sm opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out'>
          Layers
        </a>
        {/* <a href='https://read.cv/dinivannendra' target='_blank' className='text-sm opacity-50 hover:opacity-100 transition-all duration-300 ease-in-out'>
          Read CV
        </a> */}
      </div>
      <div className='flex items-center justify-between py-4 w-full'>
        <a href='https://www.google.com/search?q=ponorogo&ie=UTF-8' target='_blank' className='text-xs opacity-30 hover:opacity-70 hover:underline transition-all duration-300 ease-in-out'>Ponorogo, Indonesia</a>
        <p className='text-xs opacity-30'>{time} WIB</p>
      </div>
    </section>
  )
}
